/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Fact_WorkInputs */

const en_project_fact_work = /** @type {(inputs: Project_Fact_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our work`)
};

const lv_project_fact_work = /** @type {(inputs: Project_Fact_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mūsu darbs`)
};

/**
* | output |
* | --- |
* | "Our work" |
*
* @param {Project_Fact_WorkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_fact_work = /** @type {((inputs?: Project_Fact_WorkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Fact_WorkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_fact_work(inputs)
	return en_project_fact_work(inputs)
});